var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "currentFill"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 24.0001C11.5 23.9462 11.5 23.8908 11.5 23.8335V14.1668C11.5 13.2334 11.5 12.7664 11.6817 12.4098C11.8414 12.0962 12.0962 11.8414 12.4098 11.6817C12.7664 11.5 13.2334 11.5 14.1668 11.5H23.8335C24.7669 11.5 25.2334 11.5 25.5899 11.6817C25.9035 11.8414 26.1587 12.0962 26.3185 12.4098C26.5 12.766 26.5 13.2325 26.5 14.1641V23.8359C26.5 24.2401 26.5 24.5566 26.4852 24.8145M11.5 24.0001C11.5007 24.8237 11.5111 25.2548 11.6817 25.5895C11.8414 25.9031 12.0962 26.1587 12.4098 26.3185C12.766 26.5 13.2325 26.5 14.1641 26.5H23.8363C24.7679 26.5 25.2337 26.5 25.5899 26.3185C25.9035 26.1587 26.1587 25.9031 26.3185 25.5895C26.4213 25.3879 26.4658 25.1511 26.4852 24.8145M11.5 24.0001L15.4733 19.3646L15.4745 19.3633C15.8269 18.9522 16.0034 18.7463 16.2127 18.672C16.3966 18.6068 16.5974 18.6084 16.7804 18.6761C16.9889 18.7533 17.1625 18.9616 17.5099 19.3784L19.7359 22.0496C20.0575 22.4355 20.2192 22.6295 20.4155 22.7074C20.5887 22.7761 20.7797 22.7838 20.9584 22.7311C21.1618 22.6711 21.3409 22.492 21.699 22.134L22.1132 21.7197C22.4778 21.3551 22.6601 21.173 22.8664 21.1134C23.0476 21.0611 23.2414 21.0724 23.4157 21.1444C23.6142 21.2263 23.7752 21.427 24.0972 21.8296L26.4852 24.8145M26.4852 24.8145L26.5 24.833M21.5 16.5C21.0398 16.5 20.6667 16.1269 20.6667 15.6667C20.6667 15.2064 21.0398 14.8333 21.5 14.8333C21.9602 14.8333 22.3333 15.2064 22.3333 15.6667C22.3333 16.1269 21.9602 16.5 21.5 16.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/MediaIcon.b318ca5aeff55f347c5f9cad2c8ac38d.svg";
export { ForwardRef as ReactComponent };